<template>
  <db-nav-bar>
    <template v-slot:nav>
      <nav-bar></nav-bar>
    </template>
    <template v-slot:leftBar> </template>
    <template v-slot:rightNavBar v-if="['zb', 'cg'].indexOf(code) == -1">
      <div
        class="navRightDiv"
        v-for="(item, index) in leftList"
        :key="index"
        @click="handleClick(item.code)"
      >
        <div class="imgDiv">
          <img
            class="nav-img"
            :src="curcode === item.code ? item.activeImg : item.img"
          />
        </div>
        <div class="nameDiv">
          <span
            :style="{ color: curcode === item.code ? '#ffd60c' : '#5de9da' }"
          >
            {{ item.name }}
          </span>
        </div>
      </div>
    </template>
    <template v-slot:rightBar>
      <div class="right-bar" v-show="['zb', 'cg'].indexOf(code) == -1">
        <div @click="scrollRun()" class="i0">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="wrapper" ref="wrapper">
          <div ref="cont">
            <div
              class="scrollDiv"
              v-for="(item, index) in list"
              :key="index"
              @click="changeItem(item)"
            >
              <span
                :style="{ color: chooseId === item.id ? '#ffd60c' : '#5de9da' }"
              >
                {{ item.name }}
              </span>
            </div>
          </div>
        </div>
        <div @click="scrollRun(1)" class="i0">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="right-bar bar-two" v-show="['zb', 'cg'].indexOf(code) == -1">
        <div @click="monthClick(1)" class="i0">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="monthDiv">
          <span> {{ chooseMonth }}</span>
        </div>
        <div @click="monthClick()" class="i0">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </template>
  </db-nav-bar>
</template>

<script>
import {
  findDataKindAll,
  findDataSaleBydataKindIdGetYear,
  findDataBySCMENU
} from "@/api/schj";
import BScroll from "better-scroll";
const navBar = () => import("./navBar");
export default {
  components: {
    navBar
  },
  data() {
    return {
      scroll: null,
      curcode: "lx",
      chooseId: null,
      chooseMonth: null,
      leftList: [],
      list: [],
      dateList: [],
      monthIndex: 0
    };
  },
  computed: {
    code() {
      if (this.$store.state.schj.code !== "zb") {
        this.delyRun();
      }
      return this.$store.state.schj.code;
    }
  },
  created() {
    this.getTopLeftList();
    this.getLeftDt();
  },
  methods: {
    delyRun() {
      setTimeout(() => {
        this.verScroll();
      }, 300);
    },
    verScroll() {
      const stepX = this.$refs.cont.firstChild.clientWidth + 10;
      const option = {
        startX: 0, // 配置的详细信息请参考better-scroll的官方文档，这里不再赘述
        click: true,
        scrollX: true,
        scrollY: false,
        eventPassthrough: "vertical",
        snap: {
          loop: false,
          threshold: 0.3,
          stepX: stepX,
          speed: 400
        }
      };
      let width = this.list.length * stepX; // 动态计算出滚动区域的大小，前面已经说过了，产生滚动的原因是滚动区域宽度大于父盒子宽度
      this.$refs.cont.style.width = width + "px"; // 修改滚动区域的宽度
      // this.$refs.cont2.style.width = 12 * 64 + "px"; // 修改滚动区域的宽度
      // this.$nextTick(() => {
      if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.wrapper, option);
        // this.scroll2 = new BScroll(this.$refs.wrapper2, option);
      } else {
        this.scroll.refresh(); //如果dom结构发生改变调用该方法
        // this.scroll2.refresh();
      }
      // });
    },
    scrollRun(a) {
      // tofixd 点击过多时无效
      if (a) {
        if (this.scroll.getCurrentPage().pageX < 2) {
          this.scroll.next(300);
        }
      } else {
        this.scroll.prev(300);
      }
    },
    monthClick(a) {
      if (a) {
        if (this.monthIndex === this.dateList.length - 1) {
          return;
        } else {
          this.monthIndex++;
          this.chooseMonth = this.dateList[this.monthIndex];
        }
      } else {
        if (this.monthIndex === 0) {
          return;
        } else {
          this.monthIndex--;
          this.chooseMonth = this.dateList[this.monthIndex];
        }
      }
      this.$store.dispatch("schj/setCmonth", this.chooseMonth);
    },
    getLeftDt() {
      findDataKindAll().then(res => {
        // 右则分类
        if (res.data.length > 0) {
          this.getYearMonth(res.data[0]);
          this.list = res.data.splice(0, 6);
          this.chooseId = this.list[0].id;
          console.log("going set this.dataKindId", this.chooseId);
          this.$store.dispatch("schj/setId", this.chooseId);
          this.$store.dispatch("schj/setCname", this.list[0].name);
          //   setTimeout(() => {
          //     this.verScroll();
          //   }, 300);
        }
      });
    },
    getYearMonth(item) {
      findDataSaleBydataKindIdGetYear({ dataKindId: item.id }).then(res => {
        if (res.data.length > 0) {
          //   this.dateList = res.data; // old data like ["2021-11","2021-10","2021-09","2021-08","2021-07"]
          //   this.chooseMonth = res.data[0];
          // 修改成年份
          let arr = [];
          res.data.forEach(e => {
            let _arr = e.match(/^([\d]{4})/);
            if (_arr.length > 1) {
              let str = _arr[1];
              if (!arr.includes(str)) {
                arr.push(str);
              }
            }
          });
          this.dateList = arr;
          if (!arr.includes(this.chooseMonth)) {
            this.chooseMonth = arr[0];
            this.monthIndex = 0;
            this.$store.dispatch("schj/setCmonth", this.chooseMonth);
          }
        }
      });
    },
    changeItem(item) {
      if (item.id === this.chooseId) {
        return;
      }
      this.getYearMonth(item);
      this.$store.dispatch("schj/setCname", item.name);
      this.chooseId = item.id;
      this.$store.dispatch("schj/setId", this.chooseId);
    },
    handleClick(code) {
      if (code === this.curcode) {
        // 防止重复加载图层
        return;
      }
      this.curcode = code;
      this.$store.dispatch("schj/setCode", code);
      //重置月份和品种选择
      this.monthIndex = 0;
      this.chooseMonth = this.dateList[0];
      this.$store.dispatch("schj/setCmonth", this.chooseMonth);
      this.chooseId = this.list[0].id;
      this.$store.dispatch("schj/setId", this.chooseId);
      this.$store.dispatch("schj/setCname", this.list[0].name);
    },
    getTopLeftList() {
      findDataBySCMENU().then(res => {
        // this.leftList = res.data;
        this.leftList = res.data.map(v => {
          v.img = require("images/schj/" + v.pic.replace(".png", "l.png"));
          v.activeImg = require("images/schj/" +
            v.pic.replace(".png", "_h.png"));
          return v;
        });

        console.log("leftList", this.leftList);
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
@import '~styl/largeScreen/schjNav'
@import '~styl/smallScreen/schjNav'
// .left-bar
//     top 0
// .bar-two
//     top 40px
//     width 130px
</style>
